export const errorTypes = {
  SET_ERROR_CODE: "SET_ERROR_CODE",
  GET_ERROR_LOG_SUCCESS: "GET_ERROR_LOG_SUCCESS",
  GET_ERROR_LOG_ERROR: "GET_ERROR_LOG_ERROR",
  GET_ERROR_LOG_LOADING: "GET_ERROR_LOG_LOADING",
  RESET_ERROR_LOG: "RESET_ERROR_LOG",
};
